module.exports = __webpack_public_path__ + "static/fence-05e4b4cdb5e8c05a8adbbbd13b17bd68.jpg";